// extracted by mini-css-extract-plugin
module.exports = {"end-shift":"components-ContentHeader-Assign-Assign__end-shift--s5F2y"};